import * as types from '../actions/types';
import _ from 'lodash';
import { parseValue } from '../../utils/helpers';

const storedDescriptions = localStorage.getItem('descriptions');

const initialState = {
  data: storedDescriptions ? JSON.parse(storedDescriptions) : {},
  loading: false,
};

export default function(state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case types.GET_MARKET_DESCS_REQUEST:
      return { ...state, loading: true };
    case types.GET_MARKET_DESCS_SUCCESS:
      const { markets, outcomes, specifiers } = payload;

      const hashedMarkets = Array.from(markets).reduce((map, obj) => {
        const { names, labels, specifiers } = obj;
        let { outcomes } = obj;
        outcomes = outcomes.sort(function(a, b) {
          a = parseValue(a);
          b = parseValue(b);

          // compare string part alphabetically
          let result = a[0].localeCompare(b[0]);
          // if the string part is the same, compare the number part
          return result === 0 ? a[1] - b[1] : result;
        });
        map[obj.id] = { names, labels, specifiers, outcomes };
        return map;
      }, {});
      const hashedOutcomes = _.keyBy(outcomes, 'id');
      const hashedSpecifiers = _.keyBy(specifiers, 'code');

      return {
        ...state,
        loading: false,
        data: {
          ...state.data,
          markets: { ...state.data.markets, ...hashedMarkets },
          outcomes: { ...state.data.outcomes, ...hashedOutcomes },
          specifiers: { ...state.data.specifiers, ...hashedSpecifiers },
        },
      };

    default:
      return state;
  }
}
